import { render, staticRenderFns } from "./FaceCalibration.vue?vue&type=template&id=d23e0b50&scoped=true&"
import script from "./FaceCalibration.vue?vue&type=script&lang=js&"
export * from "./FaceCalibration.vue?vue&type=script&lang=js&"
import style0 from "./FaceCalibration.vue?vue&type=style&index=0&id=d23e0b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23e0b50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VRadio,VRadioGroup,VSimpleTable,VTextField})
